// --- Core ---
import {generatePath} from "react-router";
// --- SaniQ ---
import * as RoleConstant from '../constants';
import {fetchAPI} from "api";
import {deserializeRole, Role} from "../../../../../models/Role";
import {handleResponse} from "helpers/Requests";

function fetchRole(id) {
  const url = generatePath('/web/v1/system/roles/:id', {id});

  return fetchAPI(url).then(handleResponse<Role>(deserializeRole));
}

function deleteRole(id) {
  const url = generatePath('/web/v1/system/roles/:id', {id});

  return fetchAPI(url, 'DELETE')
    .then(handleResponse<Role>(deserializeRole));
}

function submitRole(isNew: boolean, id, payload) {
  const url = generatePath('/web/v1/system/roles/:id?', {id});

  return fetchAPI(url, isNew ? 'POST' : 'PATCH', payload)
    .then(handleResponse<Role>(deserializeRole));
}

// Requests an overview of all available roles,readable without any permissions
function fetchRoles() {
  return function (dispatch) {
    dispatch(fetchRolesStarted());
    return fetchAPI('/web/v1/roles')
      .then(handleResponse())
      .then(({content}) => {
        dispatch(fetchRolesCompleted(content));
      });
  };
}

function fetchRolesStarted() {
  return {
    type: RoleConstant.ROLES_FETCH_STARTED
  };
}

function fetchRolesCompleted(roles) {
  return {
    type: RoleConstant.ROLES_FETCH_COMPLETED,
    roles: roles
  };
}

export {
  deleteRole,
  fetchRole,
  fetchRoles,
  submitRole
};
